export const InterpolationMethod = {
    RGB: "rgb",
    LINEAR_RGB: "linearRGB"
};